import style from './style';

const Notes = () => {

	function notes() {
		return (
			<div class={style.notes}>
				<p>Some quick notes...</p>
				<p>A light source can be positioned by entering a distance and height, or by dragging the source on the drawing. Double-click to turn it on or off. Reposition the focus figures by dragging them.</p>
				<p>The height of the figure assumes that the measurement units are feet, but the dimensions are unit-free and work for feet, meters, or even parsecs.</p>
				<p>If you only want to work with the throw, enter it as the Distance, and enter 5 for the Height.</p>
				<p>In this version the beam angle and lamp choices represent the Source4 spotlight family.</p>
				<p>Values are rounded to whole numbers for clarity, and illumination to three significant figures for 1% accuracy. These are mathematical estimates only; in practice beam geometry and light output may vary from fixture to fixture.</p>
				<p>This is a work-in-progress web version of the West Side Systems <i>BeamCalc</i> iOS app. It should work in all modern browsers, including on iOS and Android devices.</p>
				{/* <p>Lots more functionality is planned. To report bugs, or help with this open-source project, visit <a href="https://github.com/escornwell/beamcalc">https://github.com/escornwell/beamcalc</a></p> */}
				<p>&copy;2021 Eric Cornwell, West Side Systems<br />version 2105091</p>
			</div>
		);
	}

	// The page
	return (
		<div>
			{notes()}
		</div>
	);
};

export default Notes;



// WEBPACK FOOTER //
// ./components/notes/index.js